module.exports = __webpack_public_path__ + "static/media/27OCHA7.9f6ddc84.jpg";